import { createContext, useReducer } from 'react';

function RowDragReducer(state,action){

  //return state;

  let type = Object.keys(action)[0];
  let rowIndex = action[type];

  if( state && state.dragging !== undefined && !['spaceAt','release'].includes(type) ){
    return state;
  }

  switch(type){
    case 'release':{
      return {};
    }
    case 'hover':{
      if( state.dragging !== undefined ){
        return state;
      }
      if( rowIndex === null || rowIndex === undefined ){
        throw Error("Row index must be defined here...");
      }
      return { hovering: rowIndex }
    }
    case 'dragging':{
      if( rowIndex === null || rowIndex === undefined ){
        throw Error("Row index must be defined here...");
      }
      return { 
        ...state,
        dragging: rowIndex 
      }
    }
    case 'spaceAt':{
      return {
        ...state,
        spaceAt:rowIndex
      }
    }
    case 'preDrag':{
      return { 
        ...state, preDrag:true
      }
    }

    case 'releasePreDrag':{
      return {
        ...state,
        preDrag:false,
      };
      if( rowIndex === state.hover ){
        return { }

        /*...state, preDrag:false ,
          hover:false,
        }*/
      }else{
        return state;
      }
    }
    default:
      throw Error("Did not handle type " + type);
  }
}

export const RowDragState = createContext();
export const RowDragDispatch = createContext();

export default function RowDragProvider({children}){

  const [ rowDragState, rowDragDispatch ] = useReducer(RowDragReducer,{});

  return (
    <RowDragDispatch.Provider value={rowDragDispatch}>
      <RowDragState.Provider value={rowDragState}>
        {children}
              </RowDragState.Provider>
    </RowDragDispatch.Provider>

  )

}
